import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "app/store.ts";
import type {
  LoadOriginsFilters,
  LoadOriginSlice,
} from "./loadOriginsTypes.ts";

const initialState: LoadOriginSlice = {
  page: 1,
  rowsPerPage: 25,
  filter: {},
  sort: {
    key: "name",
    order: "asc",
  },
};

export const loadOriginsSlice = createSlice({
  name: "loadOrigins",
  initialState,
  reducers: {
    setPage: (state, action: PayloadAction<LoadOriginSlice["page"]>) => {
      state.page = action.payload;
    },
    setRowsPerPage: (
      state,
      action: PayloadAction<LoadOriginSlice["rowsPerPage"]>,
    ) => {
      state.rowsPerPage = action.payload;
    },
    setFilter: (
      state,
      action: PayloadAction<
        [filterType: keyof LoadOriginsFilters, filterValue: string | undefined]
      >,
    ) => {
      const [filterType, filterValue] = action.payload;
      state.filter[filterType] = filterValue;
    },
    setSort: (state, action: PayloadAction<LoadOriginSlice["sort"]>) => {
      state.sort = action.payload;
    },
  },
});

export const { setPage, setRowsPerPage, setFilter, setSort } =
  loadOriginsSlice.actions;

export const selectPage = (state: RootState) => state.loadOrigins.page;
export const selectRowsPerPage = (state: RootState) =>
  state.loadOrigins.rowsPerPage;
export const selectFilter = (state: RootState) => state.loadOrigins.filter;
export const selectSort = (state: RootState) => state.loadOrigins.sort;

export default loadOriginsSlice.reducer;
